import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResizeService {
  private isMobileSubject: BehaviorSubject<boolean>;

  constructor() {
    this.isMobileSubject = new BehaviorSubject<boolean>(this.checkIsMobile());
    fromEvent(window, 'resize')
      .pipe(
        map(() => this.checkIsMobile()),
        startWith(this.checkIsMobile())
      )
      .subscribe(isMobile => this.isMobileSubject.next(isMobile));
  }

  private checkIsMobile(): boolean {
    return window.innerWidth <= 768;
  }

  get isMobile$(): Observable<boolean> {
    return this.isMobileSubject.asObservable();
  }
}
